export default __webpack_public_path__ + "static/media/slider_bg.463107a2.png";